import { useEffect, useState, useRef } from 'react';
import { v4 } from 'uuid';
import { motion } from 'framer-motion';
import { arrow } from 'utils/index';
import styles from './ShowMore.module.scss';

const ShowMore = ({children, inlineButton=true, buttonAlign="", buttonText={more:"more", less:"less"}, color="blueDark"}) => {

    const [showMore, setShowMore] = useState(false)
    const [buttonPosition, setButtonPosition] = useState(null)
    const tagContainerRef = useRef()

    useEffect(()=>{
        let buttonIndex = children.length
        if (!showMore){
            setTimeout(()=>{
                const SHOW_MORE_BTN_WIDTH = 41
                const tagsNew = Array.from(tagContainerRef.current.children)
                let currentRow = 0
                let rowThree = []
                const containerWidth = tagContainerRef.current.offsetWidth
                let lastTop = null
                for (let i = 0; i < tagsNew.length; i+=1) {
                    if (currentRow < 4) {
                        const rect = tagsNew[i]?.getBoundingClientRect()
                        const currentTop = rect.top
                        if (currentTop !== lastTop) {
                            currentRow += 1
                            lastTop = currentTop
                            if (currentRow === 3) rowThree.push(tagsNew[i])
                            continue
                        } else {
                            if (currentRow === 3) rowThree.push(tagsNew[i])
                        }
                    } else {
                        const rowWidth = rowThree.reduce((total, element)=>{
                            const style = window.getComputedStyle(element)
                            const marginRight = parseFloat(style.marginRight)
                            const borderRight = parseFloat(style.borderRight)
                            const borderLeft = parseFloat(style.borderLeft)
                            return total + element.offsetWidth + borderRight + borderLeft + marginRight
                        },0)
                        const shouldKickBack = rowWidth >= containerWidth - SHOW_MORE_BTN_WIDTH
                        buttonIndex = shouldKickBack ? i - 2 : i - 1
                        setButtonPosition(buttonIndex)
                        break
                    }
                }
            },0)
        } else {
            setButtonPosition(buttonIndex)
        }
    },[showMore])

    const ToggleButton = ({showMore}) => {
        return(
            <>
                <span onClick={()=>setShowMore(!showMore)}>
                    {showMore ?
                        <motion.span className={styles.showMore__button} initial={{opacity: 0}} animate={{opacity: 1, transition:{delay: .12}}} data-type="showMoreButton">{buttonText.less} {arrow(color, "down")}</motion.span>
                        :
                        <motion.span className={styles.showMore__button} initial={{opacity: 0}} animate={{opacity: 1, transition:{delay: .3}}} data-type="showMoreButton">{buttonText.more} {arrow(color, "up")}</motion.span>
                    }
                </span>
            </>
        )
    }

    function renderToggleButton(){
        if(inlineButton){
            return <ToggleButton showMore={showMore} key={`show-more-toggle-${v4()}`} />
        }else{
            return (
                <div className={styles.showMore__notInlineButton} style={{textAlign: buttonAlign}}>
                    <ToggleButton showMore={showMore} toggleShow={setShowMore}/>
                </div>
            )
        }
    }

    let completeList = children.slice(0)
    if (buttonPosition !== null) completeList.splice(buttonPosition, 0, renderToggleButton());
    return(
        <div className={`${styles.showMore} ${styles[`showMore-${color}`]}`}>
            <div ref={tagContainerRef} className={showMore ? null : styles.overflow_hidden_categories_for_mobile}>
                {completeList}
            </div>
        </div>
    )
}

export default ShowMore;
